<template>
  <div class="kpi-card">
    <div class="kpi-card-icon">
      <font-awesome-icon :icon="icon" />
    </div>
    <div class="kpi-card-body">
      <div class="kpi-card-value">{{ value }}</div>
      <div class="kpi-card-label">{{ label }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    icon: { type: [String, Array], required: true },
    value: { type: [String, Number], required: true },
    label: { type: String, required: true },
  },
});
</script>
